export const isReturnStartEligible = (sale) => Boolean(sale && sale.ka_sent != null && [
  'KA_SENT_BUYER', 'DONE', 'DONE_BY_ADMIN', 'DONE_BY_BUYER', 'DONE_BY_CRON',
].includes(sale.status));
